/*
 * Author: harper
 * File Created: Saturday, 23-10-07 11:52 am
 * Last Modified: Tuesday, 24-11-19 03:09 pm, by Roger
 * Copyright © 2023 - wello wallet MIT
 */
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

// update from https://www.figma.com/design/w89XIcAJwfzL0E1KIJzPkq/DeCard%E8%A7%84%E8%8C%83?node-id=244-1214&node-type=canvas&m=dev
function Card(props: SvgIconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-component="Card" data-sentry-source-file="index.tsx">
      <path fillRule="evenodd" clipRule="evenodd" d="M18.5 5.3H5.5C4.83726 5.3 4.3 5.83726 4.3 6.5V17.5C4.3 18.1627 4.83726 18.7 5.5 18.7H18.5C19.1627 18.7 19.7 18.1627 19.7 17.5V6.5C19.7 5.83726 19.1627 5.3 18.5 5.3ZM5.5 3.5C3.84315 3.5 2.5 4.84315 2.5 6.5V17.5C2.5 19.1569 3.84315 20.5 5.5 20.5H18.5C20.1569 20.5 21.5 19.1569 21.5 17.5V6.5C21.5 4.84315 20.1569 3.5 18.5 3.5H5.5Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="index.tsx" />
      <path d="M4 8H20V9.8H4V8Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="index.tsx" />
      <path d="M6 15.4C6 14.9029 6.40294 14.5 6.9 14.5H11.1C11.5971 14.5 12 14.9029 12 15.4C12 15.8971 11.5971 16.3 11.1 16.3H6.9C6.40294 16.3 6 15.8971 6 15.4Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="index.tsx" />
    </svg>;
}
export default Card;